/* eslint-disable no-mixed-operators */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-this-in-sfc */
import { DownOutlined } from '@ant-design/icons';
import { faFill, faFont } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dropdown, Menu, Select, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateComponentSettings } from '../../redux/board/reducer';
import { CUSTOM_GROUP_ID, eventBus, FONT_SIZE, getFonts, GROUP, IMAGE, TEXT_SETTINGS } from '../../utils';
import ColorPicker from '../ColorPicker';

import './styles.scss';

const { Option } = Select;

export default ({ styles = [] }) => {
  const dispatch = useDispatch();
  const componentSettings = useSelector((state) => state.board.componentSettings);

  const isAllStyleTrue = (type) =>
    styles.length > 0
      ? styles.reduce((a, c) => a.concat(c[type]), []).every((v) => v === true || v === 'italic' || v === 'bold')
      : false;
  const checkType = (type) => {
    const isTrue = isAllStyleTrue(type);
    return isTrue;
  };

  const initStyle = {
    fontWeight: checkType('fontWeight') ? 'bold' : 'normal',
    fontStyle: checkType('fontStyle') ? 'bold' : 'normal',
    underline: false,
    linethrough: false,
    superscript: false,
    subscript: false,
    fontSize: 12,
    fontFamily: 'Helvetica',
    textAlign: 'left',
    textBackgroundColor: styles.length > 0 ? styles[0].textBackgroundColor : '#ffffff',
    fill: styles.length > 0 ? styles[0].fill : 'black',
  };

  const [style, setStyle] = useState(initStyle);
  const [fontSize, setFontSize] = useState('');
  const [visible, setVisible] = useState(false);

  const updateStyles = (data) => {
    let result = {};
    if (componentSettings.textSettings) {
      result = {
        ...componentSettings,
        textSettings: {
          ...componentSettings.textSettings,
          ...data,
        },
      };
    } else {
      result = {
        ...componentSettings,
        ...data,
      };
    }
    dispatch(updateComponentSettings(result));
  };

  function handleMenuClick(e) {
    const newFontSize = FONT_SIZE[e.key];
    setFontSize(FONT_SIZE[e.key]);
    setStyle((oldS) => ({
      ...oldS,
      fontSize: newFontSize,
    }));
    setVisible(false);
    updateStyles({ fontSize: newFontSize });
  }

  useEffect(() => {
    if (componentSettings) {
      const result = componentSettings.textSettings || componentSettings;
      setFontSize(Math.round(result.fontSize) || '');
      setStyle(result);
    }
  }, [componentSettings]);

  const onSetStyle = (data) => {
    if (data.text) {
      let result = {};
      Object.keys(data.style).forEach((item) => {
        if (['textAlign'].includes(item)) {
          result = { ...result, [item]: data.style.textAlign };
          return;
        }
        if (['listType'].includes(item)) {
          result = { ...result, listType: data.style.listType };
          return;
        }
        if (['background', 'textbackgroundColor'].includes(item)) {
          const isEveryStyle = data.text
            .getSelectionStyles()
            .every((i) => Object.keys(i).includes(item) && i.textBackgroundColor === data.style.textbackgroundColor);
          if (isEveryStyle || (!isEveryStyle && !Object.keys(data.text.getSelectionStyles()[0]).includes(item))) {
            result = { ...result, textBackgroundColor: data.style.textbackgroundColor };
          } else {
            result = { ...result, textBackgroundColor: '' };
          }
          return;
        }
        const checkStyle = data.text
          .getSelectionStyles()
          .every((i) => Object.keys(i).includes(item) && i[item] === data.style[item]);
        if (checkStyle || (!checkStyle && !Object.keys(data.text.getSelectionStyles()[0]).includes(item))) {
          result = { ...result, [item]: data.style[item] };
        } else {
          result = { ...result, [item]: '' };
        }
      });
      setStyle(result);
      const checkFontSize = data.text
        .getSelectionStyles()
        .every((i) => Object.keys(i).includes('fontSize') && i.fontSize === data.style.fontSize);
      if (checkFontSize || (!checkFontSize && !Object.keys(data.text.getSelectionStyles()[0]).includes('fontSize'))) {
        setFontSize(Math.round(data.style.fontSize));
      } else {
        setFontSize('');
      }
    }
  };

  const onCustomStyle = (obj) => {
    const data = { ...style, ...obj };
    setStyle(data);
    setFontSize(obj.fontSize || '');
  };

  useEffect(() => {
    eventBus.on('on-update-settings-form', onSetStyle);
    return () => {
      eventBus.off('on-update-settings-form', onSetStyle);
    };
  }, []);

  useEffect(() => {
    eventBus.on('set-style-settings-form', onCustomStyle);
    return () => {
      eventBus.off('set-style-settings-form', onCustomStyle);
    };
  }, []);

  const menu = (
    <Menu onClick={handleMenuClick}>
      {FONT_SIZE.map((f, index) => (
        <Menu.Item key={index} style={{ backgroundColor: f === fontSize ? '#4eccf5' : 'inherit' }}>
          {f}
        </Menu.Item>
      ))}
    </Menu>
  );

  const onAlignClick = (value) => {
    const data = {
      ...style,
      textAlign: value,
    };
    setStyle(data);
    eventBus.emit('handle-text-alignment', value);
  };

  const onColorChange = (color, type) => {
    const key = type === 'textBackgroundColor' ? 'textBackgroundColor' : 'fill';
    const obj = { [key]: color };
    const data = {
      ...style,
      ...obj,
    };
    setStyle(data);
    updateStyles(obj);
  };

  const onSelectChange = (e) => {
    const data = {
      ...style,
      fontFamily: e,
    };
    setStyle(data);
    updateStyles({ fontFamily: e });
  };

  const onSizeChange = (e) => {
    e.stopPropagation();
    let value = e.target.value.replace(/[^0-9]\d-/g, '');
    if (e.target.value.trim() === '') {
      value = '0';
    }
    if (parseInt(value) > 76) {
      value = '76';
    }
    if (parseInt(value) < 0) {
      value = '';
    }
    setFontSize(parseInt(value));
  };

  const onKeyDown = (e) => {
    e.stopPropagation();
    if (e.keyCode === 13) {
      if (fontSize <= 0) {
        setFontSize('');
        updateStyles({ fontSize: '' });
      } else {
        updateStyles({ fontSize: fontSize });
      }
    }
    setVisible(false);
  };

  const renderSelect = (action) => {
    const options = [...getFonts()];
    const type = 'fontFamily';
    return (
      <div className="font-select">
        <Tooltip title="Font Family">
          <Select
            showSearch
            onChange={(e) => onSelectChange(e)}
            className="select-form"
            value={style[type] ? style[type] : ''}
          >
            {options && options.length ? (
              options.map((i, index) => (
                <Option key={index} value={i} style={action === 'font' ? { fontFamily: i } : {}}>
                  <div>{i}</div>
                </Option>
              ))
            ) : (
              <Option key="" />
            )}
          </Select>
        </Tooltip>
      </div>
    );
  };
  const getColor = (type) => style[type];
  const renderColorPicker = (action) => {
    const type = action === 'fill' ? 'fill' : 'textBackgroundColor';
    const title = action === 'fill' ? 'Text Color' : 'Background Color';
    const icon = action === 'fill' ? faFont : faFill;
    return (
      <div className="color-picker">
        <span className="icon">
          <FontAwesomeIcon icon={icon} style={{ fontSize: '16px' }} />
        </span>
        <Tooltip title={title}>
          {/* <Input
            value={style[type] ? style[type] : '#ffffff'}
            type="color"
            style={{ height: '30px', width: '40px' }}
            onChange={(event) => onColorChange(event, type)}
          /> */}
          <ColorPicker onChange={onColorChange} type={type} color={style[type] || getColor(type)} place="settings" />
        </Tooltip>
      </div>
    );
  };

  const renderFontSize = () => (
    <div className="size-select">
      <Tooltip title="Font Size">
        <Dropdown overlay={menu} trigger={['click']} open={visible}>
          <Button
            className="menu"
            onClick={() => {
              setVisible(!visible);
            }}
          >
            <div className="span">
              <input value={fontSize || ''} onKeyDown={onKeyDown} onChange={onSizeChange} className="size-input" />
              <DownOutlined
                style={{
                  marginTop: '4px',
                  verticalAlign: 'middle',
                  fontSize: '12px',
                  transform: 'translateX(5px)',
                }}
              />
            </div>
          </Button>
        </Dropdown>
      </Tooltip>
    </div>
  );

  const renderAlignButton = (types) => {
    const textAlignGroupButton = TEXT_SETTINGS.filter((item) => item.action === 'textAlign')[0];
    const alignButtons = textAlignGroupButton.list.filter((item) => types.includes(item.value));
    return (
      <div style={{ display: 'flex' }}>
        {alignButtons.map((item, index) => (
          <Tooltip key={index} title={item.tooltipLabel}>
            <Button
              className={style.textAlign === item.value ? 'btn-active' : 'text-btn'}
              icon={item.icon}
              type="default"
              onClick={() => onAlignClick(item.value)}
            />
          </Tooltip>
        ))}
      </div>
    );
  };

  const shouldRender = () => {
    const activeObj = window.canvas.getActiveObject();
    if (!activeObj) return false;
    if ([IMAGE].includes(activeObj.type)) return false;

    if ([GROUP].includes(activeObj.type)) {
      const { id = '' } = activeObj;
      const groupHasOneObj = !id.includes(CUSTOM_GROUP_ID) && activeObj?.getObjects().length === 1;
      if (groupHasOneObj || activeObj.colorSetting) {
        return true;
      }
      return false;
    }
    return true;
  };

  return shouldRender() ? (
    <div className="mo__text-editor">
      <div className="col-2" style={{ marginBottom: '1rem' }}>
        {renderSelect('font')}
        {renderFontSize()}
      </div>
      <div className="color-picker-group">
        {renderColorPicker('fill')}
        {renderColorPicker('background')}
      </div>
      <div className="grid">
        {renderAlignButton(['left', 'center', 'right'])}
        {renderAlignButton(['top', 'middle', 'bottom'])}
      </div>
    </div>
  ) : (
    <div />
  );
};
